<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-4" v-if="canCreate()">
            <button class="btn btn-secondary btn-fg custom-shadow-btn" @click="$router.push('/demands/create')">
              <i class="fa fa-plus"></i>
              Agregar Estudio de Demanda
            </button>
          </div>
        </div>
        <hr>
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('demandas', 'Demandas', 'a4', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('demandas', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('demandas', tableData, tableColumns)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border
                      ref="tableModule">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="150"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Descargar'" class="btn-danger btn-simple btn-link"
                     @click="handlePreviewDownload(props.$index, props.row)"><i class="fa fa-download"></i></a>
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i></a>
                  <a v-if="canUpdate()" v-tooltip.top-center="'Editar'" class="btn-warning btn-simple btn-link"
                     @click="handleEdit(props.$index, props.row)"><i
                    class="fa fa-edit"></i></a>
                  <a v-if="canDelete()" v-tooltip.top-center="'Borrar'" class="btn-danger btn-simple btn-link"
                     @click="handleDelete(props.$index, props.row)"><i class="fa fa-times"></i></a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="text-right">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('demandas', 'Demandas', 'a4', tableData, tableColumns)"><i class="fa fa-file-pdf-o"></i>
            Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-center">
        <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('demandas', tableData, tableColumns)"><i class="fa fa-file-excel-o"></i>
        Exportar a Excel
      </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-left">
        <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('demandas', tableData, tableColumns)"><i class="fa fa-file-text-o"></i>
          Exportar a CSV
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p v-if="isShow">A continuación encontrarás toda la información asociada al registro seleccionado.</p>
        <p v-else>Por favor selecciona uno o todos los archivos a descargar.</p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <table class="table">
              <tbody v-if="rowData">
                <template v-if="isShow">
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Código:</b></h6>
                      {{rowData.code}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Nombre:</b></h6>
                      {{rowData.name}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Descripción:</b></h6>
                      {{rowData.description}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Fecha de Inicio:</b></h6>
                      {{rowData.start_date}}
                    </td>
                  </tr>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6><b>Fecha de Terminación:</b></h6>
                      {{rowData.finish_date}}
                    </td>
                  </tr>
                </template>
                  <tr class="shadow-sm">
                    <td scope="row">
                      <h6 class="custom-margin-h6-table" ><b>Anexos:</b></h6>
                      <el-tag
                        :closable="false"
                        :close-transition="false"
                        type="success"
                        effect="dark"
                        v-if="rowData.annexes.length > 1"
                          class="tag-click"
                        @click="handlePreview('all', rowData)">
                          <i class="fa fa-copy"></i>Descargar Todos
                      </el-tag>
                      <template v-for="(annex, index) in rowData.annexes">
                        <el-tag :key="annex"
                          type="warning"
                          class="tag-click"
                          effect="dark"
                          @click="handlePreview(index, annex)"
                          :closable="false"
                          :close-transition="false">
                            {{annex}}
                        </el-tag>
                        <br :key="index+'Index'" v-if="(((index+1) % 4) == 0)"/>
                      </template>
                      <el-tag v-if="rowData.annexes.length == 0">No tiene anexos adjuntos</el-tag>
                    </td>
                  </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer footer-date-at" v-if="rowData">
            <p class="text-muted"><small>Creado el: {{rowData.created_at}}</small></p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import showSwalAlert from 'src/util/alerts'
  import axios from 'axios'
  import table from './demandTable'
  import moment from 'moment'

  export default {
    data () {
      return {
        demandsForm: {},
        tableColumns: table,
        isShow: true,
        rangeDate: [new Date((new Date().getFullYear()), 0, 1), new Date((new Date().getFullYear()), 11 + 1, 0)]
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker],
    methods: {
      handleView (index, row) {
        this.isShow = true
        this.rowData = Object.assign({}, row)
        this.rowData.created_at = moment(String(this.rowData.created_at)).format('MM/DD/YYYY hh:mm:ss')
        this.title = this.rowData.name
        this.modals['read'] = true
      },
      handleEdit (index, row) {
        this.demandsForm = Object.assign({}, row)
        this.demandsForm.roles = row.roles_ids
        localStorage.setItem( 'demandEdit', JSON.stringify(this.demandsForm) )
        this.$router.push({ name: 'Editar Demanda' });
      },
      handleDelete (index, row) {
        this.demandsForm = Object.assign({}, row)
        showSwalAlert('Demanda', 'delete', true, null, 'Demnada: '+row.name).then((result) => {
          if (result.value) this.deleteModule()
        })
      },
      handlePreviewDownload (index, row) {
        this.handleView(index, row)
        this.isShow = false
      },
      handlePreview(index, annex) {
        this.$emit('cotentLoading', true)
        axios({
          url: 'https://dialnet.aplicacionescorporativas.com/dialnet-backend/api/auth/demands/download/'+this.rowData.id+'/'+index,
          method: "GET",
          responseType: "blob",
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", index == 'all' ? 'anexos.zip' : this.rowData.annexes[index]);
          document.body.appendChild(link);
          link.click();
          this.$emit('cotentLoading', true)
        }).catch((error) => this.showMessageErrors(error));
      },
      deleteModule(){
        this.$emit('cotentLoading', true)
        this.demandsForm.route = 'demands'
        this.destroyMaster(this.demandsForm)
          .then((response) => this.modifyTable(2, this.demandsForm.id, response))
          .catch((error) => this.showMessageErrors(error))
      },
    },
    created(){
      this.$emit('cotentLoading', true)
      if(this.canIndex()){
        this.getMasters('demands').then((response) => {
          this.tableData = response.data.data
          this.searchFuse(['code', 'name', 'description'])
          this.$emit('cotentLoading', false)
        }).catch((error) => this.showMessageErrors(error))
      }
    },
  }
</script>
<style>
</style>
